import React from "react";
import Lottie from "lottie-react";
import triangleLoading from "../../assets/triangle-loading.json";

const TriangleLoading = () => {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  };

  // const textStyle = {
  //   color: "rgb(93, 47, 34)",
  //   fontSize: "14px",
  //   marginTop: "8px",
  //   fontFamily: "'Noto Serif TC', serif",
  //   textAlign: "center",
  //   animation: "fadeInOut 2s ease-in-out infinite",
  // };

  const keyframes = `
    @keyframes fadeInOut {
      0%, 100% { opacity: 0.4; }
      50% { opacity: 1; }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div style={containerStyle}>
        <Lottie
          animationData={triangleLoading}
          loop
          autoplay
          style={{ width: 200, height: 200 }}
        />
        {/* <p style={textStyle}>正在解析命盤⋯⋯</p> */}
      </div>
    </>
  );
};

export default TriangleLoading;
